import { gql } from '@apollo/client';

export const USER_UPDATE = gql`
  mutation UserUpdate(
    $id: ID!
    $name: String!
    $email: String!
    $roles: [String!]!
    $isVerified: Boolean
  ) {
    userUpdate(id: $id, name: $name, email: $email, roles: $roles, isVerified: $isVerified)
  }
`;

export const USER_DELETE = gql`
  mutation UserUpdate($id: ID!) {
    userDelete(id: $id)
  }
`;
